module.exports = __webpack_public_path__ + "static/media/Dr_Duc_Tran.d6415fbc.png";